import React from 'react';

import { useAuth } from 'features/auth/AuthProvider';
import { login } from 'features/auth/api/authApi';
import Button from 'components/ui/Button/Button';

import './LoginPage.css';

export default function LoginPage() {
  const { setToken, errorText, setErrorText } = useAuth();
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState(errorText);

  const handleLogin = async (event) => {
    if (event) event.preventDefault();
    try {
      setErrorText(null);
      const response = await login(email, password);
      setToken(response.token);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-container">
      <div className="card login-card">
        <h1>Please login</h1>

        {error && <p className="error-text">{error}</p>}

        <form className="form" onSubmit={handleLogin}>
          <div className="field">
            <label htmlFor="login_email">Email</label>
            <input
              type="text"
              id="login_email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
            />
          </div>
          <div className="field">
            <label htmlFor="login_password">Password</label>
            <input
              type="password"
              id="login_password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          <Button type="submit">Login</Button>
        </form>
      </div>
    </div>
  );
}
